// extracted by mini-css-extract-plugin
export default {"intro":"Header_intro__LYYhO","ben":"Header_ben__oodhp"};